<template>
  <v-container id="CandidateRegistrationComponent">
    <v-row>
      <v-col cols="12">
        <v-stepper
          id="stepper"
          v-model="step"
          alt-labels
        >
          <h1 class="header">
            Register
          </h1>
          <h5 class="subheader">
            (all fields marked * are mandatory)
          </h5>
          <v-stepper-header class="elevation-0 step-header">
            <v-stepper-step
              color="agency-color-primary"
              :complete="step > 1"
              step="1"
              class="text-center"
            >
              Personal Details
            </v-stepper-step>

            <v-divider />

            <v-stepper-step
              color="agency-color-primary"
              :complete="step > 2"
              step="2"
            >
              Contact Details
            </v-stepper-step>

            <v-divider />

            <v-stepper-step
              color="agency-color-primary"
              :complete="step > 3"
              step="3"
            >
              Industry &amp; Job Titles
            </v-stepper-step>

            <v-divider />

            <v-stepper-step
              color="agency-color-primary"
              :complete="step > 4"
              step="4"
            >
              Next of Kin / Emergency Contact
            </v-stepper-step>

            <v-divider />

            <v-stepper-step
              color="agency-color-primary"
              :complete="step > 5"
              step="5"
            >
              Other
            </v-stepper-step>

            <v-divider />

            <v-stepper-step
              color="agency-color-primary"
              :complete="step > 6"
              step="6"
            >
              WFA
            </v-stepper-step>

            <v-divider v-if="!!tenant.settings.terms_conditions" />

            <v-stepper-step
              v-if="!!tenant.settings.terms_conditions"
              color="agency-color-primary"
              step="7"
            >
              T&amp;Cs
            </v-stepper-step>
          </v-stepper-header>
          <div
            v-if="v1APIError !== null"
            class="subheader v1-error"
            style="{}"
          >
            <h5 class="v1-error-title">
              {{ v1APIError.title }}
            </h5>
          </div>
          <v-stepper-items class="step-items">
            <v-stepper-content step="1">
              <personal-details
                :candidate="newCandidate"
                :pg-error="pgError"
                @next="addDataToCandidate($event, 2)"
                @loginBack="loginBack()"
              />
            </v-stepper-content>
            <v-stepper-content step="2">
              <contact-details
                :candidate="newCandidate"
                :log-detail="logDetail"
                :exist-account="existAccount"
                :pg-error="pgError"
                @next="addDataToCandidate($event, 3)"
                @back="goBack()"
              />
            </v-stepper-content>
            <v-stepper-content step="3">
              <industry-details
                :candidate="newCandidate"
                @next="addDataToCandidate($event, 4)"
                @back="goBack()"
              />
            </v-stepper-content>
            <v-stepper-content step="4">
              <nok-details
                :candidate="newCandidate"
                @next="addDataToCandidate($event, 5)"
                @back="goBack()"
              />
            </v-stepper-content>
            <v-stepper-content step="5">
              <other-details
                :candidate="newCandidate"
                @next="addDataToCandidate($event, 6)"
                @back="goBack()"
              />
            </v-stepper-content>
            <v-stepper-content step="6">
              <work-finders-signature
                v-if="!loading && noErrors"
                :candidate="newCandidate"
                :tenant="tenant"
                @next="addDataToCandidate($event, 7)"
                @submit="
                  addDataToCandidateThenSubmit($event, step)
                "
                @back="goBack()"
              />
              <div
                v-else-if="loading"
                class="d-flex flex-column justify-center align-center"
              >
                <v-progress-circular
                  indeterminate
                  color="agency-color-primary"
                  size="100"
                />
                <p class="mt-4">
                  Creating your account. Please wait, this may take a minute. Do not refresh the page.
                </p>
              </div>
            </v-stepper-content>
            <v-stepper-content
              v-if="!!tenant.settings.terms_conditions"
              step="7"
            >
              <terms-conditions-signature
                v-if="!loading && noErrors"
                :candidate="newCandidate"
                :tenant="tenant"
                @next="addDataToCandidate($event, 7)"
                @submit="
                  addDataToCandidateThenSubmit($event, step)
                "
                @back="goBack()"
                @goTo="goTo(step)"
              />
              <div
                v-else-if="loading"
                class="d-flex flex-column justify-center align-center"
              >
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="100"
                />
                <p class="mt-4">
                  Creating your account. Please wait, this may take a minute. Do not refresh the page.
                </p>
              </div>
            </v-stepper-content>
            <v-stepper-content step="error">
              <v-alert
                class="d-flex flex-column justify-center align-center"
              >
                <div v-if="errorCode === 422">
                  <v-list>
                    <v-list-item
                      v-for="(error, i) in errors"
                      :key="i"
                    >
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="error"
                        />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
                <p
                  v-else-if="errorCode !== ''"
                  class="mt-4 text-center"
                >
                  We're sorry, something has gone wrong
                  <br>Please try again later or contact the
                  agency with the the details provided.
                </p>
                <v-btn
                  tile
                  color="agency-color-secondary"
                  @click="goBackForErrors"
                >
                  Back
                </v-btn>
              </v-alert>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'CandidateRegistrationComponent',
  props: {
    candidate: {
      type: Object,
      default: () => {
        let defaultCandidate = {
          candidate_details: {},
          candidate_nok: {}
        }
        if (localStorage.getItem('candidate_register')) {
          defaultCandidate = JSON.parse(
            localStorage.getItem('candidate_register')
          )
        }
        return defaultCandidate
      }
    },
    showRegister: {
      type: Boolean,
      default: false
    },

    tenant: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    noErrors: true,
    gender: [
      { text: 'Male', value: 'M' },
      { text: 'Female', value: 'F' }
    ],
    newCandidate: {
      candidate_nok: {}
    },
    v1APIError: null,
    logDetail: {},
    existAccount: false,
    confirmPassword: '',
    step: 1,
    errorStep: 1,
    industries: [],
    jobs: [],
    errors: [],
    errorCode: '',
    pgError: {
      personal: {
        firstName: '',
        lastName: '',
        gender: '',
        identifies_as: '',
        dob: '',
        niNumber: ''
      },
      contact: {
        mobile: '',
        email: '',
        password: '',
        confirm_password: '',
        address1: '',
        address2: '',
        country: '',
        postCode: ''
      }
    }
  }),
  computed: {
    //
  },
  created () {
    this.logDetail = this.$parent.logDetail
    this.existAccount = this.$parent.existAccount
    this.newCandidate = _.clone(this.candidate)
    const context = this
    context.logDetail = this.logDetail
    axios.get(context.URLs.core.industries.root).then(response => {
      context.industries = response.data.data
    })

    const urlParams = new URLSearchParams(window.location.search)
    const clearSet = urlParams.get('clear')

    if (clearSet) {
      localStorage.clear()
      window.location.href = '/register'
    }

    if (
      this.newCandidate.candidate_details === undefined &&
            this.newCandidate.candidate_nok === undefined
    ) {
      if (localStorage.getItem('candidate_register')) {
        this.newCandidate = JSON.parse(
          localStorage.getItem('candidate_register')
        )
      } else {
        this.newCandidate = {
          candidate_details: {},
          candidate_nok: {}
        }
      }
    }
  },
  methods: {
    goBackForErrors () {
      this.noErrors = true
      this.step = this.errorStep
    },
    addDataToCandidate (event, step = false) {
      const context = this
      _.forEach(event, function (o, key) {
        if (Object.keys(context).includes(key)) {
          Object.assign(context[key], o)
        }
      })
      if (step) {
        context.step = step
      }
    },
    addDataToCandidateThenSubmit (event, step) {
      const context = this
      context.addDataToCandidate(event)
      context.loading = true
      this.v1APIError = null
      context.newCandidate.exist_account = this.existAccount
      context.newCandidate.id = context.candidate
        ? context.candidate.id
        : null
      context.newCandidate.credential = {
        password: context.newCandidate.password
      }
      delete context.newCandidate.password
      if (
        context.newCandidate.id &&
                context.newCandidate.password === null
      ) {
        delete context.newCandidate.credential
      }

      axios
        .post(context.URLs.core.candidates.candidateRegister, {
          candidate: context.newCandidate
        })
        .then(response => {
          localStorage.removeItem('candidate_register')
          window.location.href = '/documents'
        })
        .catch(error => {
          context.loading = false

          if (error.response.status === 500 && error.response.data.type === 'V1 API Error') {
            this.v1APIError = {
              title: error.response.data.message,
              body: error.response.data.body
            }
          }

          let foundFlag = false
          const errors = error.response.data.errors
          const tabs = error.response.data.tabs

          if (
            errors['candidate.candidate_details.ni_number'] !==
                            undefined ||
                        errors['candidate.first_name'] !== undefined ||
                        errors['candidate.last_name'] !== undefined ||
                        errors['candidate.gender'] !== undefined ||
                        errors['candidate.date_of_birth'] !== undefined
          ) {
            const oKey = Object.keys(errors)[0]
            const keys = oKey.split('.')
            this.pgError.personal[
              this.formatPgErrorKey(keys[keys.length - 1])
            ] = errors[oKey]
            this.goTo(1)
            foundFlag = true
          }

          if (Array.isArray(errors) && Array.isArray(tabs)) {
            if (tabs.length > 0) {
              if (
                tabs[0] === 'contact.postCode' ||
                                tabs[0] === 'contact.email' ||
                                tabs[0] === 'contact.password'
              ) {
                const errKey = tabs[0].split('.')
                this.pgError.contact[errKey[1]] = errors[0]
                this.goTo(2)
                foundFlag = true
              }
            }
          }

          if (!foundFlag) {
            context.noErrors = false
            context.errorCode = error.response.status
            context.step = 'error'
            context.errorStep = step
            if (error.response.status === 422) {
              context.errors = error.response.data.errors
            }
          }
        })
    },
    formatPgErrorKey (str) {
      const frags = str.split('_')
      for (let i = 0; i < frags.length; i++) {
        if (i > 0) {
          frags[i] =
                        frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
        }
      }
      return frags.join('')
    },
    goTo (step) {
      this.step = step
    },
    goBack () {
      this.step--
    },
    loginBack () {
      window.axios
        .get('/check-last-active')
        .then(response => {
          if (response.data.message === 'logged') {
            this.logout()
          } else {
            window.location.href = this.getBaseUrl()
          }
        })
        .catch(() => {
          window.location.href = this.getBaseUrl()
        })
    },
    getBaseUrl () {
      return window.location.origin
        ? window.location.origin + '/'
        : window.location.protocol + '/' + window.location.host + '/'
    },
    logout () {
      const formData = new FormData()
      formData.append('_method', 'POST')
      axios.post(this.URLs.core.auth.logout, formData).then(response => {
        window.location.href = this.getBaseUrl()
      })
    }
  }
}
</script>
<style lang="scss">
@import "./resources/sass/variables";
@import "./resources/sass/agencyTheming";

#CandidateRegistrationComponent {
    #stepper {
        width: 100%;
        align-self: center;
        overflow-y: auto;
        max-height: 80vh;

        .step-header {
            display: none;

            @media screen and (min-width: 450px) {
                display: flex;
            }
        }
    }

    .header {
        padding: 1rem 1.5rem 0;
    }

    .subheader {
        padding: 0 1.5rem 0;
    }

    .textField {
        padding: 0 1rem;
    }
}

.v1-error {
    width: 90%;
    margin: 0 auto;
    padding: 0 5rem;
    background-color: rgba(255, 0, 0, 0.3);
    color: red;
    border-radius: 0.3rem;
}

.v1-error-title {
    font-size: 1.1rem;
    font-weight: 600;
    padding: 0.5rem 1rem;
}

.v1-error-body {
    font-size: 1rem;
    padding: 0.5rem 1rem;
}
</style>
